import Histogram from './Histogram';
import HorizontalHistogram from './HorizontalHistogram';
import LineChart from './LineChart';
import ScatterPlot from './ScatterPlot';

export {
  Histogram,
  HorizontalHistogram,
  LineChart,
  ScatterPlot,
};



// WEBPACK FOOTER //
// ./src/index.ts